// import { useSelector, useDispatch } from 'react-redux';
// import { setUser, clearUser, syncUser } from '../redux/localSlice';
// import { useEffect, useState } from 'react';
// import keys from 'config/keys';
// // const getUserFromStorage = () => {
// // 	try {
// // 		// 1. Check sessionStorage first
// // 		const sessionUser = sessionStorage.getItem('user');
// // 		if (sessionUser) {
// // 			const parsed = JSON.parse(sessionUser);
// // 			return {
// // 				...parsed,
// // 				roleName: parsed?.roles?.[0]?.roleName || parsed?.role || 'user',
// // 			};
// // 		}

// // 		// 2. Fallback to localStorage
// // 		const localUser = localStorage.getItem('user');
// // 		if (localUser) {
// // 			const parsed = JSON.parse(localUser);
// // 			sessionStorage.setItem('user', localUser); // Sync to sessionStorage
// // 			return {
// // 				...parsed,
// // 				roleName: parsed?.roles?.[0]?.roleName || parsed?.role || 'user',
// // 			};
// // 		}

// // 		return null;
// // 	} catch (error) {
// // 		console.error('Failed to parse user data:', error);
// // 		return null;
// // 	}
// // };

// // const useUserSession = () => {
// // 	// Initialize synchronously with stored user
// // 	const [user, setUser] = useState(() => getUserFromStorage());

// // 	console.log({ user });

// // 	// Optional: Add storage event listener for cross-tab sync
// // 	const handleStorageChange = useCallback((e) => {
// // 		if (e.key === 'user') {
// // 			setUser(getUserFromStorage());
// // 		}
// // 	}, []);

// // 	useState(() => {
// // 		window.addEventListener('storage', handleStorageChange);
// // 		return () => window.removeEventListener('storage', handleStorageChange);
// // 	});

// // 	return {
// // 		user,
// // 		role: user?.userRole,
// // 		isAdmin: user?.userRole === 'admin' || user?.userRole === 'superAdmin',
// // 		isAuthenticated: !!user,
// // 		// Bonus: Add methods to update storage
// // 		updateUser: (newUser) => {
// // 			const userData = JSON.stringify(newUser);
// // 			sessionStorage.setItem('user', userData);
// // 			localStorage.setItem('user', userData);
// // 			setUser(getUserFromStorage());
// // 		},
// // 		clearUser: () => {
// // 			sessionStorage.removeItem('user');
// // 			localStorage.removeItem('user');
// // 			setUser(null);
// // 		},
// // 	};
// // };
// // hooks/useUserSession.js

// const useAgencyLogo = () => {
// 	const [agencyLogo, setAgencyLogo] = useState(null);

// 	useEffect(() => {
// 		const checkLogo = async () => {
// 			try {
// 				const logo = localStorage.getItem('AgencyLogo');

// 				if (!logo || logo === 'null' || logo === 'undefined') {
// 					setAgencyLogo(null);
// 					return;
// 				}

// 				const logoUrl = `${keys.productApiUrl}api/${logo}`;

// 				const response = await fetch(logoUrl, {
// 					method: 'HEAD',
// 				});

// 				console.log({ response });

// 				if (response.ok) {
// 					setAgencyLogo(logoUrl);
// 				} else {
// 					setAgencyLogo(null);
// 				}
// 			} catch (error) {
// 				console.error('Logo fetch error:', error);
// 				setAgencyLogo(null);
// 			}
// 		};

// 		checkLogo();
// 	}, []);

// 	return agencyLogo;
// };

// export const useUserSession = () => {
// 	const dispatch = useDispatch();
// 	const user = useSelector((state) => state.user.user);
// 	const agencyName =
// 		user?.tenant?.agencyName ||
// 		localStorage.getItem('workspaceAgencyName') ||
// 		'Default Agency';

// 	const agencyLogo = useAgencyLogo();
// 	// const agencyLogo = `${process.env.REACT_APP_CRM_PRODUCT_API_URL}api/${localStorage.getItem('AgencyLogo')}`;
// 	// useEffect(() => {
// 	// 	const handleStorageChange = (e) => {
// 	// 		if (e.key === 'user') {
// 	// 			dispatch(syncUser());
// 	// 		}
// 	// 	};
// 	// 	window.addEventListener('storage', handleStorageChange);
// 	// 	return () => window.removeEventListener('storage', handleStorageChange);
// 	// }, [dispatch]);

// 	return {
// 		agencyName,
// 		agencyLogo,
// 		user,
// 		userRoleName: user?.roleName,
// 		isSuperAdmin:
// 			user?.roleName === 'superAdmin' || user?.role === 'superAdmin',
// 		isAdmin: user?.roleName === 'Admin',
// 		isAuthenticated: !!user,
// 		updateUser: (newUser) => dispatch(setUser(newUser)),
// 		clearUser: () => dispatch(clearUser()),
// 	};
// };

// export default useUserSession;

import { useSelector, useDispatch } from 'react-redux';
import { setUser, clearUser } from '../redux/localSlice';
import { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import keys from 'config/keys';

// Global cache with status tracking
let logoCache = {
	url: null,
	status: 'idle', // 'idle' | 'loading' | 'success' | 'error'
	timestamp: null,
	lastChecked: null,
};

const useAgencyLogo = () => {
	const [agencyLogo, setAgencyLogo] = useState(logoCache.url);
	const mountedRef = useRef(true);
	const fetchTimeoutRef = useRef(null);

	const getLogoFromStorage = useCallback(() => {
		return localStorage.getItem('AgencyLogo');
	}, []);

	useEffect(() => {
		mountedRef.current = true;

		const fetchLogo = async () => {
			// Don't fetch if already loading or already successful
			if (logoCache.status === 'loading') return;
			
			// If we already have a valid logo, use it
			if (logoCache.status === 'success' && logoCache.url) {
				setAgencyLogo(logoCache.url);
				return;
			}

			// If we already tried and failed, only retry after 5 minutes
			if (logoCache.status === 'error' && logoCache.timestamp) {
				const timeSinceError = Date.now() - logoCache.timestamp;
				if (timeSinceError < 5 * 60 * 1000) { // 5 minutes
					setAgencyLogo(null);
					return;
				}
			}

			try {
				logoCache.status = 'loading';
				
				const logo = getLogoFromStorage();

				if (!logo || logo === 'null' || logo === 'undefined') {
					logoCache.status = 'error';
					logoCache.url = null;
					logoCache.timestamp = Date.now();
					if (mountedRef.current) {
						setAgencyLogo(null);
					}
					return;
				}

				const logoUrl = `${keys.productApiUrl}api/${logo}`;

				// Add a timeout to the fetch
				const controller = new AbortController();
				const timeoutId = setTimeout(() => controller.abort(), 5000);

				const response = await fetch(logoUrl, {
					method: 'HEAD',
					signal: controller.signal,
					cache: 'no-cache',
				});

				clearTimeout(timeoutId);

				if (response.ok && mountedRef.current) {
					logoCache.status = 'success';
					logoCache.url = logoUrl;
					logoCache.timestamp = Date.now();
					logoCache.lastChecked = logo;
					setAgencyLogo(logoUrl);
				} else {
					logoCache.status = 'error';
					logoCache.url = null;
					logoCache.timestamp = Date.now();
					logoCache.lastChecked = logo;
					if (mountedRef.current) {
						setAgencyLogo(null);
					}
				}
			} catch (error) {
				console.error('Logo fetch error:', error);
				logoCache.status = 'error';
				logoCache.url = null;
				logoCache.timestamp = Date.now();
				if (mountedRef.current) {
					setAgencyLogo(null);
				}
			}
		};

		// Check if logo in storage has changed
		const currentLogo = getLogoFromStorage();
		const hasChanged = currentLogo !== logoCache.lastChecked;

		// Only fetch if:
		// 1. Status is idle, OR
		// 2. Logo has changed, OR
		// 3. Status is error and 5 minutes have passed
		if (logoCache.status === 'idle' || hasChanged) {
			fetchLogo();
		} else if (logoCache.status === 'success' && logoCache.url) {
			setAgencyLogo(logoCache.url);
		} else if (logoCache.status === 'error') {
			setAgencyLogo(null);
		}

		// Listen for storage changes (other tabs)
		const handleStorageChange = (e) => {
			if (e.key === 'AgencyLogo') {
				// Reset cache to idle so it refetches
				logoCache.status = 'idle';
				logoCache.lastChecked = null;
				fetchLogo();
			}
		};

		window.addEventListener('storage', handleStorageChange);

		// Listen for custom logo update event
		const handleLogoUpdate = (e) => {
			if (e.detail?.logo !== undefined) {
				// Reset cache
				logoCache.status = 'idle';
				logoCache.lastChecked = null;
				fetchLogo();
			}
		};

		window.addEventListener('logoUpdated', handleLogoUpdate);

		return () => {
			mountedRef.current = false;
			window.removeEventListener('storage', handleStorageChange);
			window.removeEventListener('logoUpdated', handleLogoUpdate);
			if (fetchTimeoutRef.current) {
				clearTimeout(fetchTimeoutRef.current);
			}
		};
	}, [getLogoFromStorage]);

	return agencyLogo;
};

export const useUserSession = () => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.user.user);
	
	const agencyName = useMemo(() => {
		return user?.tenant?.agencyName ||
			localStorage.getItem('workspaceAgencyName') ||
			'Default Agency';
	}, [user]);

	const agencyLogo = useAgencyLogo();

	const updateAgencyLogo = useCallback((newLogo) => {
		if (newLogo) {
			localStorage.setItem('AgencyLogo', newLogo);
		} else {
			localStorage.removeItem('AgencyLogo');
		}
		// Reset cache and dispatch event
		logoCache.status = 'idle';
		logoCache.lastChecked = null;
		window.dispatchEvent(new CustomEvent('logoUpdated', { detail: { logo: newLogo } }));
	}, []);

	return {
		agencyName,
		agencyLogo,
		user,
		userRoleName: user?.roleName,
		isSuperAdmin: user?.roleName === 'superAdmin' || user?.role === 'superAdmin',
		isAdmin: user?.roleName === 'Admin',
		isAuthenticated: !!user,
		updateUser: (newUser) => dispatch(setUser(newUser)),
		clearUser: () => {
			dispatch(clearUser());
			// Clear logo cache on logout
			logoCache.status = 'idle';
			logoCache.url = null;
			logoCache.lastChecked = null;
		},
		updateAgencyLogo,
	};
};

export default useUserSession;